import { useGoalsStore } from "@/apps/goals/store/goalsStore";
import { getCurrentGoalData } from "@/apps/goals/utils/goalsState";

export const useCurrentGoalData = (completedFallback = false) => {
  const initData = useGoalsStore((state) => state.initData);
  const goalData = getCurrentGoalData(initData);

  return {
    ...goalData,
    completedRides: completedFallback
      ? goalData.assignment?.rides ?? goalData.ridesRequired
      : goalData.completedRides,
  };
};
